import script from "./ConnectSocialConfirmDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConnectSocialConfirmDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ConnectSocialConfirmDialog.vue?vue&type=style&index=0&id=677ca896&lang=sass"

const __exports__ = script;

export default __exports__